import { render } from "./Pessoa.vue?vue&type=template&id=0b6da4e8&scoped=true"
import script from "./Pessoa.vue?vue&type=script&lang=js"
export * from "./Pessoa.vue?vue&type=script&lang=js"

import "./Pessoa.vue?vue&type=style&index=0&id=0b6da4e8&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6da4e8"]])

export default __exports__